import(/* webpackMode: "eager" */ "/vercel/path0/app/(dashboard)/generate/page.tsx");
